<c-card *transloco="let t">
    <c-card-body class="px-2">

        <c-row>
          <c-col class="col-12 col-lg-6">
            <h1>{{ t('Map Zone Summary') }}</h1>
          </c-col>
          <c-col class="col-12 col-lg-6 text-end mb-2">
            <c-row class="justify-content-end">
              <c-col xs="auto">

                <button color="light" cButton class="m-1" routerLink="/mgmt/safetyzones">
                  <svg cIcon class="me-2" name="cil-chevron-left"></svg>
                  {{ t('Return to Map Zones') }}
                </button>
                &nbsp;&nbsp;&nbsp;

              </c-col>
            </c-row>
          </c-col>
        </c-row>
        <c-row>
          <c-col class="col-12">
            <div class="alert alert-info alert-dismissible fade show" role="alert" *ngIf="!okService.isDismissed('safety_zones_summary')">
              <i class="fa-solid fa-circle-info"></i> {{ t('The Map Zone summary shows the location of all the workers currently on shift, if they are in the correct zone, missing from the zone or do not have location turned on.') }}
              <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" (click)="okService.doDismiss('safety_zones_summary')"></button>
            </div>
          </c-col>
        </c-row>


        <c-row>

            <ng-container *ngFor="let safety_zone of safety_zones">
                <c-col class="col-12 col-md-6 mb-3">
                <div class="card">
                    <h5 class="card-header">
                    {{ t('Summary for') }} {{safety_zone.name}}
                    </h5>
                    <div class="card-body">
                        <div class="row">
                            <div class="col">
                                <h2>{{safety_zone.worker_ids.length}} <span class="badge bg-info">{{ t('Assigned Workers') }}</span></h2>
                                <h2>{{safety_zone.summary.assigned.length}} <span class="badge bg-success">{{ t('Workers in Zone') }}</span></h2>
                                <h2>{{safety_zone.summary.missing.length}} <span class="badge bg-warning">{{ t('Missing from Zone') }}</span></h2>
                                <h2>{{safety_zone.summary.no_location.length}} <span class="badge bg-danger">{{ t('No Location') }}</span></h2>
                                <br/><Br/>
                                <button type="button" class="btn btn-outline-secondary btn-sm mb-1" (click)="viewWorkers(safety_zone)"><i class="fa-solid fa-users"></i> {{ t('View all Workers') }}</button>
                            </div>
                            <div class="col">
                                <img [src]="safety_zone.map" class="img-fluid img-thumbnail" alt="Map Zone for {{safety_zone.name}}" class="safety-zone-img">
                            </div>

                        </div>
                    </div>
                </div>
                </c-col>
            </ng-container>

        </c-row>

        <!-- Modal -->
        <div class="modal fade" id="summaryModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg">
            <div class="modal-content" *ngIf="safety_zone">
                <div class="modal-header">
                <h1 class="modal-title fs-5" id="exampleModalLabel">{{ t('Summary of the Workers for') }} {{safety_zone.name}}</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="table-responsive">
                        <table class="table table-striped">
                            <thead>
                                <th></th>
                                <th>{{ t('Name') }}</th>
                                <th>{{ t('Phone') }}</th>
                                <th>{{ t('Last Location') }}</th>
                            </thead>
                            <tbody>
                                <tr  *ngFor="let worker of safety_zone.summary.assigned">
                                    <td><h3><span class="badge bg-success">{{ t('Working in Zone') }}</span></h3></td>
                                    <th>{{worker.name}}</th>
                                    <td>{{worker.phone}}</td>
                                    <td>{{worker.last_location}}</td>
                                </tr>
                                <tr  *ngFor="let worker of safety_zone.summary.missing">
                                    <td><h3><span class="badge bg-warning">{{ t('Missing from Zone') }}</span></h3></td>
                                    <th>{{worker.name}}</th>
                                    <td>{{worker.phone}}</td>
                                    <td>{{worker.last_location}}</td>
                                </tr>
                                <tr  *ngFor="let worker of safety_zone.summary.no_location">
                                    <td><h3><span class="badge bg-danger">{{ t('No Location') }}</span></h3></td>
                                    <th>{{worker.name}}</th>
                                    <td>{{worker.phone}}</td>
                                    <td>{{ t('None') }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            </div>
        </div>

    </c-card-body>
</c-card>
